import Translate from "component/global/translation/translation-component";

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { Box, ListItemIcon, Skeleton } from "@mui/material";

interface DisplayPlatformPackageComponentProps {
    hasPlatformPackage: boolean;
    isLoading?: boolean;
    packageName?: string | null;
}

const DisplayPlatformPackageComponent = ({
    hasPlatformPackage,
    isLoading = false,
    packageName
}: DisplayPlatformPackageComponentProps) => {
    const displayText = hasPlatformPackage
        ? (packageName || "---")
        : "--- No Platform Package ---";

    return (
        <Box sx={{ display: "flex", alignItems: "center", minWidth: 240 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
                <BusinessCenterIcon fontSize="small" color="action" />
            </ListItemIcon>
            {isLoading ? (
                <Skeleton variant="text" width={160} />
            ) : (
                <Translate text={displayText} />
            )}
        </Box>
    );
}

export default DisplayPlatformPackageComponent;
